
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { addGcashAccount, setConnectivityTest } from '@/api/gcash/account'
import {
  getAbandonReasonList,
  addAbandonReasonList,
} from '@/api/task/antOrderReview'
import { Form as ElForm } from 'element-ui'

@Component({
  name: 'addAccount',
  components: {},
})
export default class extends Vue {
  private infoForm: any = {
    label: '',
    value: '',
  }
  private rules: any = {
    label: [
      {
        required: true,
        message: 'Please enter label',
        trigger: 'blur',
      },
    ],
    value: [{ required: true, message: 'Please enter value', trigger: 'blur' }],
  }

  private testLoading: boolean = false
  private loading: boolean = false

  private back() {
    this.infoForm = {
      phone_number: '',
      account_password: '',
      account_id: '',
      sms_id: '',
    }
    this.$emit('close')
  }

  // private async connectivityTest() {
  //   try {
  //     this.testLoading = true
  //     const data: any = {
  //       action: 'start_login',
  //       data: {
  //         msisdn: this.infoForm.phone_number
  //       }
  //     }
  //     await setConnectivityTest(data).then(() => {
  //       this.$message({
  //         message: 'Sent，Please Check！',
  //         type: 'success'
  //       })
  //       this.testLoading = false
  //     })
  //   } catch (error) {
  //     this.testLoading = false
  //   }
  // }

  private async create() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          const data: any = {
            ...this.infoForm,
          }
          console.log(data)
          await addAbandonReasonList(data).then((res: any) => {
            this.$message({
              message: 'Create successful!',
              type: 'success',
            })
            this.loading = false
            this.back()
          })
        } catch (error) {
          this.loading = false
        }
      }
    })
  }

  mounted() {}
}
